/** @format */

import {makeStyles} from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    height: '48px',
    gap: theme.spacing(2),
    transition: '0.2s',
    background: 'none',
    borderRadius: '8px',
    padding: theme.spacing(0, 4),

    fontSize: '16px',
    color: theme.palette.figma_surface?.light,
    lineHeight: '20px',
    fontWeight: 400,

    '&.MuiButtonBase-root .MuiSvgIcon-root': {
      fontSize: '16px',
      transition: '0.2s',
      color: theme.palette.figma_surface?.light,
    },

    '&:hover': {
      color: theme.palette.figma_gray_light_4?.main,
      background: '#316e9f',

      '&.MuiButtonBase-root .MuiSvgIcon-root': {
        color: theme.palette.figma_gray_light_4?.main,
      },
    },

    [`${theme.breakpoints.down('md')}`]: {
      width: '100%',
      justifyContent: 'flex-start',
    },
  },

  selected: {
    color: theme.palette.figma_primary?.dark,
    background: 'none',

    '&.MuiButtonBase-root .MuiSvgIcon-root': {
      color: theme.palette.figma_primary?.dark,
    },

    '&:hover': {
      color: theme.palette.figma_primary?.dark,
      background: 'none',

      '&.MuiButtonBase-root .MuiSvgIcon-root': {
        color: theme.palette.figma_primary?.dark,
      },
    },
  },

  active: {
    color: theme.palette.figma_gray_light_4?.main,
    background: theme.palette.figma_primary?.dark,

    '&.MuiButtonBase-root .MuiSvgIcon-root': {
      color: theme.palette.figma_gray_light_4?.main,
    },

    '&:hover': {
      color: theme.palette.figma_gray_light_4?.main,
      background: theme.palette.figma_primary?.dark,

      '&.MuiButtonBase-root .MuiSvgIcon-root': {
        color: theme.palette.figma_gray_light_4?.main,
      },
    },
  },
}));
